import { PAYMENT_STATUS, PAYMENT_TYPE } from 'modules/entity/subEntities/intervention/constants';

/**
 * @param {import('modules/entity/subEntities/intervention/types').Payment} payment
 * @returns {boolean}
 */
export const isPaymentSuccess = ({ type, status }) => status === PAYMENT_STATUS.SUCCESS && type !== PAYMENT_TYPE.EXTERNAL;

/**
 * @param {import('modules/entity/subEntities/intervention/types').Payment} payment
 * @returns {boolean}
 */
export const isPaymentFailure = ({ status }) => status === PAYMENT_STATUS.ABORTED || status === PAYMENT_STATUS.FAILED;

/**
 * @param {import('modules/entity/subEntities/intervention/types').Payment[]} payments
 * @returns {import('modules/entity/subEntities/intervention/types').Payment | undefined}
 */
export const getMostRecentPayment = (payments = []) =>
  (payments.length
    ? payments.reduce((latest, current) => (new Date(current.modifiedOn) > new Date(latest.modifiedOn) ? current : latest))
    : undefined);
